var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 6.25H7.5C7.16848 6.25 6.85054 6.3817 6.61612 6.61612C6.3817 6.85054 6.25 7.16848 6.25 7.5V32.5C6.25 32.8315 6.3817 33.1495 6.61612 33.3839C6.85054 33.6183 7.16848 33.75 7.5 33.75H32.5C32.8315 33.75 33.1495 33.6183 33.3839 33.3839C33.6183 33.1495 33.75 32.8315 33.75 32.5V15.5178C33.75 15.3536 33.7177 15.1911 33.6548 15.0394C33.592 14.8878 33.5 14.75 33.3839 14.6339L25.3661 6.61612C25.25 6.50004 25.1122 6.40797 24.9606 6.34515C24.8089 6.28233 24.6464 6.25 24.4822 6.25V6.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6377 15.0012H25V6.36372",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 8H10V12.1667H14.1667V16.3333H10V20.5H14.1667V24.6667H10V28.8333H14.1667V33H18.3333V28.8333L14.1667 28.8333V24.6667H18.3333V20.5H14.1667V16.3333H18.3333V12.1667H14.1667V8Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default __webpack_public_path__ + "static/media/icon-zip.ba1dfbf1b14a427b38cfc333a25f4de4.svg";
export { ForwardRef as ReactComponent };